// Fix for Safari/Instagram in-app browser autofill error
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){};

import { onReady } from './helpers/document-helper.js';
import { initContactForm } from './components/contact-form.js';
import { initPaymentModal } from './components/payment-modal.js';
import { initCookieConsent } from './components/cookie-consent.js';
import { EcommerceTracking } from './components/ecommerce-tracking.js';
import { initErrorTracking } from './components/error-tracking.js';

// Expose EcommerceTracking globally for inline scripts
if (typeof window !== 'undefined') {
    window.EcommerceTracking = EcommerceTracking;
}

// Initialize error tracking as early as possible
initErrorTracking();

const originalOnReady = onReady;

function onReadyWrapper() {
    originalOnReady();
    initContactForm();
    initPaymentModal();
    initCookieConsent();
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReadyWrapper, { once: true });
} else {
    onReadyWrapper();
}